import {DescriptionText, FlexContainer, H1Text, H2Text, Hr} from "../../../../../design";
import {AmountDivideByHundred} from "../../../../../helper";
import React from "react";
import SmallScreenHeader from "../../../../../components/smallscreen/header";
import currencyFormatter from "../../../../../utils/currencyformatter";

type Props = {
  invoice: Object,
  finalPayableAmount: Number,
  cancelUrlLink: String,
}

const InvoicePayHeader = (props:Props) => {
  const { invoice, finalPayableAmount, cancelUrlLink } = props;

  const customContainerProps = {
    // borderWidth: '5px !important',
    // borderColor: '#000 !important',
    // borderStyle: 'solid !important',
    borderRadius: '10px !important',
    width: '100%',
    padding: '5% !important',
    backgroundColor: '#fff',
  };

  const customFlexContainerProps = {
    width: '100%',
  }

  const customPrimaryHeadingProps = {
    fontWeight: 'bold',
    marginTop: '5px',
    marginBottom: '5px',
    fontSize: '20px',
  };

  const customSecondaryHeadingProps = {
    fontWeight: 'bold',
    textTransform: 'none',
    marginRight: '10px',
  }

  const customDescriptionProps = {
    fontSize: '18px',
    whiteSpace: 'wrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  };

  return (
    <SmallScreenHeader cancelUrlLink={cancelUrlLink}>
      <FlexContainer {...customContainerProps}>
        <H1Text {...customPrimaryHeadingProps}>
          Payment Checkout
        </H1Text>
        <Hr/>
        <FlexContainer {...customFlexContainerProps}>
          <H2Text {...customSecondaryHeadingProps}>
            Payment For
          </H2Text>
          <DescriptionText {...customDescriptionProps}>
            {invoice && invoice.description}
          </DescriptionText>
        </FlexContainer>
        <FlexContainer {...customFlexContainerProps}>
          <H2Text {...customSecondaryHeadingProps}>
            {invoice && invoice?.invoiceType === "PARTIAL" ? "Partial Payment" : "Amount Payable"}
          </H2Text>
          {invoice && invoice?.invoiceType !== "PARTIAL" &&
            <DescriptionText {...customDescriptionProps}>
              {invoice.currency && currencyFormatter(AmountDivideByHundred(invoice.total), invoice.currency?.name)}
            </DescriptionText>
          }
          {invoice && invoice?.invoiceType === "PARTIAL" &&
            <DescriptionText {...customDescriptionProps}>
              {invoice.currency && currencyFormatter(AmountDivideByHundred(finalPayableAmount), invoice.currency?.name)}
            </DescriptionText>
          }
        </FlexContainer>
      </FlexContainer>
    </SmallScreenHeader>
  )
};

export default InvoicePayHeader
